import { Component, OnInit } from '@angular/core';
import { LibroService } from 'src/app/servicios/libro.service';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-libro',
  templateUrl: './libro.component.html',
  styleUrls: ['./libro.component.scss']
})
export class LibroComponent implements OnInit {

  public libros$:Observable<any[]>

  constructor(private libroSvc:LibroService, private router:Router) { }

  ngOnInit(): void {
   
      this.libros$ = this.libroSvc.getAllCursos();

  }

  ira(url)
  {    
    window.open(url, "_blank");
  }

}
